module.exports = __webpack_public_path__ + "img/expo_bg.a35de568.jpg";